import { IResponse } from "models";

export enum ActionType {
  STRESS_CHECK_LIST = "action/STRESS_CHECK_LIST",
  STRESS_CHECK_LIST_SUCCESS = "action/STRESS_CHECK_LIST_SUCCESS",
  STRESS_CHECK_LIST_ERROR = "action/STRESS_CHECK_LIST_ERROR",
  STRESS_CHECK_LIST_RESET_DATA = "action/STRESS_CHECK_LIST_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface StressCheckListData {
  page: number;
  per_page: number;
  language_code?: string;
  locale?: string;
}

export interface IStressCheckListResponse extends IResponse {
  total_record: number;
  current_page: number;
  next_page: number;
  result?: IStressCheck[];
}

export interface IStressCheck {
  id: number;
  name: string;
  stress_check_type_id: number;
  examination_period: string;
  status: number;
  implement_status: string;
  color_code_status: string;
}
